if (!customElements.get('featured-circle-collection')) {
  class FeaturedCircleSlider extends HTMLElement {
    constructor() {
      super();
      if (Shopify.designMode) {
        window.addEventListener('shopify:section:load', function () {
          this.init();
        });
      }
      this.init();
    }

    init () {
      this.swiper = new Swiper(".featured__circle__collections", {
        autoplay: {
          delay: 3500,
          disableOnInteraction: false,
        },
        spaceBetween: 10,
        slidesPerView: 4.5,
        breakpoints: {
          1280: {
            spaceBetween: 10,
            slidesPerView: 11.5
          },
          990: {
            spaceBetween: 10,
            slidesPerView: 9.5
          },
          750: {
            spaceBetween: 10,
            slidesPerView: 7.5
          },
          480: {
            spaceBetween: 10,
            slidesPerView: 5.5
          }
        }
      });
    }
  }

  customElements.define('featured-circle-collection', FeaturedCircleSlider);
}
